<template>
<div class="picture_report_form" :style="screenHeight">
    <Spin size="large" fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>正在加载中...</div>
    </Spin>
    <div class="fixed_search" style="height: 50px">
        <div class="date_selected fixed_search_input">
            <el-date-picker :clearable="false" v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期" align="left" :default-time="['00:00:00', '23:59:59']" :editable="editable" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <div class="fixed_search_input">
            <Select v-model="employeeDepartment" placeholder="请选择所属部门" clearable>
                <Option v-for="(option, index) in departmentList" :value="option.id" :key="index">{{option.groupname}}</Option>
            </Select>
        </div>
        <div class="fixed_search_input compare_select">
            <Select v-model="compareCallInCount" clearable title="呼入符号">
                <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Input v-model="callInCount" placeholder="呼入数量" title="呼入数量" />
        </div>
        <div class="fixed_search_input compare_select">
            <Select v-model="compareCalloutCount" clearable title="呼出符号">
                <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Input v-model="calloutCount" placeholder="呼出数量" title="呼出数量" />
        </div>
        <div class="fixed_search_input" style="width: 5%">
            <Input v-model="showCount" placeholder="当前显示部门量" title="当前显示部门量" />
        </div>
        <div class="fixed_operation_btn">
            <Button type="primary" @click="initSearch">查询</Button>
            <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        </div>
    </div>
    <Tabs v-model="pictureIndex" :style="pictureHeight">
        <TabPane label="饼状图" name="pancake">
            <div id="pancakeTotalDept" class="customer_total" style="width: 85%;height: 85%;"></div>
        </TabPane>
        <TabPane label="柱状图" name="columnar">
            <div id="columnarTotalDept" class="customer_total" style="width: 85%;height: 85%;"></div>
        </TabPane>
    </Tabs>
    <div class="fixed_table" style="margin-top: 35px;border: 1px solid #DCDFE6">
        <div class="table_head" style="border-top: 0px">
            <table>
                <tr>
                    <th class="font_style_set" style="width:40%;">部门</th>
                    <th class="font_style_set" style="width:30%;">呼入接通数量</th>
                    <th class="font_style_set" style="width:30%;">呼出接通数量</th>
                </tr>
            </table>
        </div>
        <div class="footer_style" :style="tableHeight">
            <table class="table_head_footer">
                <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                    <td style="width:40%;">{{item.groupName}}</td>
                    <td style="width:30%;">{{item.callinCount}}</td>
                    <td style="width:30%;">{{item.calloutAnswer}}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import {
    publicFunClass
} from '@/components/js/PublicFunClass.js'
export default {
    name: "DepartCallPicture",
    mixins: [publicFunClass],
    props: {
        pageCode: String
    },
    data() {
        return {
            showPageCount: 0,
            editable: false,
            spinShow: true,
            infoTableList: [],
            screenHeight: {
                height: ''
            },
            tableHeight: {
                height: ''
            },
            pictureHeight: {
                height: ''
            },
            compareList: [{
                'id': '>',
                'name': '大于'
            }, {
                'id': '=',
                'name': '等于'
            }, {
                'id': '<',
                'name': '小于'
            }, {
                'id': '>=',
                'name': '大于等于'
            }, {
                'id': '<=',
                'name': '小于等于'
            }],
            formTypeList: [{
                'id': '1',
                'name': '时报'
            }, {
                'id': '2',
                'name': '日报'
            }, {
                'id': '3',
                'name': '周报'
            }, {
                'id': '4',
                'name': '月报'
            }],
            popSign: '座席通话统计导出',
            journalType: "null",
            menuId: "null",
            formType: '2',
            starEndTime: [this.getDate(new Date(), '00:00:00'), this.getDate(new Date(), '23:59:59')],
            employeeDepartment: '',
            departmentList: [],
            compareCallInCount: '',
            callInCount: '',
            compareCalloutCount: '',
            calloutCount: '',
            showCount: '10',
            pictureIndex: 'pancake',
            columnarXData: [],
            columnar1: [],
            columnar2: [],
            lineXData: [],
            pancakeTotal: []
        }
    },
    methods: {
        initSearch: function () {
            let that = this;
            let param = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                formType: this.formType,
                date: this.starEndTime.length == 0 ? "" : this.starEndTime.toString(),
                employeeDepartment: this.employeeDepartment,
                compareCallInCount: this.compareCallInCount,
                callInCount: this.callInCount,
                compareCalloutCount: this.compareCalloutCount,
                calloutCount: this.calloutCount,
                showCount: this.showCount,
                journalType: "null",
                menuId: "null"
            };
            that.spinShow = true;
            that.columnarXData = [];
            that.columnar1 = [];
            that.columnar2 = [];
            that.pancakeTotal = [{
                value: 0,
                name: '呼入接通数量'
            }, {
                value: 0,
                name: '呼出接通数量'
            }];
            this.$http.post("callAgentByGroup/toGraphical.json", param).then(function (res) {
                let result = res.data;
                that.spinShow = false;
                if (result.flag != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }
                that.infoTableList = res.data.obj.list.content;
                let contentList = res.data.obj.list.content;
                if (contentList.length > 0) {
                    let sumSuccessLegin = 0;
                    let sumSuccessLegout = 0;
                    for (let i = 0; i < contentList.length; i++) {
                        sumSuccessLegout = sumSuccessLegout + parseInt(contentList[i].calloutAnswer);
                        sumSuccessLegin = sumSuccessLegin + parseInt(contentList[i].callinCount);
                        that.columnar1.push(parseInt(contentList[i].callinCount));
                        that.columnar2.push(parseInt(contentList[i].calloutAnswer));
                        that.columnarXData.push(contentList[i].groupName);
                    }
                    that.pancakeTotal[0].value = sumSuccessLegin;
                    that.pancakeTotal[1].value = sumSuccessLegout;
                }
                that.departmentList = res.data.obj.dept;
                that.initPancakeTotal();
                that.initColumnarTotal();
            })
        },
        reset: function () {
            this.starEndTime = [this.getDate(new Date(), '00:00:00'), this.getDate(new Date(), '23:59:59')],
                this.formType = "2";
            this.employeeDepartment = "";
            this.compareCallInCount = "";
            this.callInCount = "";
            this.compareCalloutCount = "";
            this.calloutCount = "";
            this.showCount = "10";
        },
        initPancakeTotal: function () {
            let that = this;
            let pancakeTotal = this.$echarts.init(document.getElementById('pancakeTotalDept'));
            pancakeTotal.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c}通 ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 2,
                    data: ['呼入接通数量', '呼出接通数量'],
                    textStyle: {
                        fontSize: 14
                    }
                },
                color: ['#79c6d8', '#fddca9'],
                series: [{
                    name: '座席通话统计',
                    type: 'pie',
                    radius: ['60%', '90%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'left',
                        normal: {
                            show: true,
                            color: '#515a6e',
                            fontSize: '16',
                            formatter: '{b}\n{c}通',
                            position: 'inside'
                        }
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '18',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: true
                    },
                    data: that.pancakeTotal
                }]
            });
        },
        initColumnarTotal: function () {
            let that = this;
            let columnarTotal = this.$echarts.init(document.getElementById('columnarTotalDept'));
            columnarTotal.setOption({
                tooltip: {
                  formatter:'{a}<br/>{b}: {c}通'
                },
                legend: {
                    data: ['呼入接通数量', '呼出接通数量'],
                },
                xAxis: {
                    data: that.columnarXData,
                    axisLabel: {
                        interval: 0,
                    }
                },
              yAxis: [{
                minInterval:1,
                type:'value'
              }],
                series: [{
                        name: '呼入接通数量',
                        type: 'bar',
                        barMaxWidth: 25,
                        data: that.columnar1,
                        color: '#79c6d8'
                    },
                    {
                        name: '呼出接通数量',
                        type: 'bar',
                        barMaxWidth: 25, // 最大宽度
                        data: that.columnar2,
                        color: '#fddca9'
                    }
                ]
            });
        }
    },
    created() {
        this.screenHeight.height = this.mountHeight(92);
        this.pictureHeight.height = this.mountHeight(172);
        this.tableHeight.height = this.mountHeight(250);
        this.initSearch();
        this.initPancakeTotal();
        this.initColumnarTotal();
    },
    watch: {
        pageCode: function () {
            // if (this.pageCode == '8_4-3' && this.showPageCount == 0) {
            //     this.showPageCount++;
            //
            // }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/PictureReportForm/DepartCallPicture.vue